module.exports = __webpack_public_path__ + "img/img27.7a73519f.svg";